import tokens from './tokens'
import lpTokens from './lpTokens'
import { MultiPoolConfig } from './types'

const multiPool: MultiPoolConfig = {
  earningTokens: [tokens.wftm, lpTokens.pgunk_ftm_spirit_lp, tokens.egunk, tokens.r4id, tokens.gem],
  contractAddress: {
    250: '0xb9a7d9b0aec1d87d15efa3897ec87a9b843a1611',
    4002: '0x7c11903f2dccc4f430c069537fe5e08a074ec13f',
  },
}

export default multiPool
